// @ts-nocheck
import { MOCK, invalidateAndRefresh } from "@/state/app-store";
import { UI } from "@/components/ui";
import { Icon } from "@/components/icons";
import { api, gamesApi, adminApi } from "@/api/index";

const { $, $$, fmtNum, fmtMoney, fmtPercent, toast, confirmModal, hasPerm, statusBadge, trendArrow, statCard, channelChip, capabilityBadge, pageHeader, emptyState, primaryBtn, ghostBtn, stepIndicator, BUSINESS_COLORS, chartTooltip, chartXAxis, chartYAxis, chartLineSeries, chartBarSeries } = UI;

declare const echarts: any;
declare const Pages: Record<string, any>;
declare const PageHooks: { mounted?: ((path: string) => void) | null };
declare function navigate(path: string): void;
declare function getCurrentPath(): string;
declare function getCurrentPathWithQuery(): string;
declare function renderRoute(): void;

if (typeof window !== "undefined") {
  (window as any).Pages = (window as any).Pages || {};
}

const Pages = (window as any).Pages;

// __legacy_global_aliases__
// Resolve cross-module helpers via window (legacy SPA globals)
const packagePlatformCode = (...args: any[]) => (window as any).packagePlatformCode(...args);
const renderPackageRow = (...args: any[]) => (window as any).renderPackageRow(...args);
const roleBadge = (...args: any[]) => (window as any).roleBadge(...args);


// ============================================================
// 编辑游戏（Edit Game）· 多 Tab 完整表单
// 路由：/dev/games/:id/edit?tab=...
// ============================================================

window.Pages = window.Pages || {};

// 游戏品类联动配置：一级品类 -> 二级子类
const GAME_CATEGORY_TREE = {
  "Casual / 休闲": ["Match-3 / 三消", "Merge / 合成", "Runner / 跑酷", "Arcade / 街机", "Word / 文字", "Trivia / 问答", "Hidden Object / 找物", "Bubble Shooter / 泡泡龙", "Solitaire / 单人纸牌"],
  "Puzzle / 益智解谜": ["Logic / 逻辑", "Physics / 物理解谜", "Escape Room / 密室逃脱", "Jigsaw / 拼图", "Brain Training / 脑力训练", "Tile Match / 方块匹配", "Puzzle RPG / 解谜 RPG"],
  "RPG / 角色扮演": ["MMORPG / 大型多人在线 RPG", "ARPG / 动作 RPG", "Turn-based RPG / 回合制 RPG", "Gacha RPG / 抽卡 RPG", "Idle RPG / 放置 RPG", "Tactical RPG / 战棋 RPG", "JRPG / 日式 RPG", "Roguelike RPG / 肉鸽 RPG"],
  "Strategy / 策略": ["SLG / 大地图策略", "RTS / 即时战略", "Tower Defense / 塔防", "4X / 4X 策略", "Auto Chess / 自走棋", "City Builder / 城建策略", "War Strategy / 战争策略", "Turn-based Strategy / 回合策略"],
  "Action / 动作": ["Platformer / 平台跳跃", "Fighting / 格斗", "Hack and Slash / 砍杀", "Beat 'em up / 清版动作", "Roguelike Action / 肉鸽动作", "Brawler / 乱斗"],
  "Shooter / 射击": ["FPS / 第一人称射击", "TPS / 第三人称射击", "Battle Royale / 大逃杀", "Tactical Shooter / 战术射击", "Hero Shooter / 英雄射击", "Bullet Hell / 弹幕射击", "Rail Shooter / 轨道射击"],
  "Simulation / 模拟经营": ["Life Simulation / 生活模拟", "Farming / 农场", "Tycoon / 大亨经营", "City Building / 城市建造", "Cooking / 烹饪餐厅", "Decoration / 装修装扮", "Pet Simulation / 宠物模拟"],
  "Sports & Racing / 体育竞速": ["Football / 足球", "Basketball / 篮球", "Tennis / 网球", "Golf / 高尔夫", "Arcade Racing / 街机竞速", "Simulation Racing / 模拟赛车", "Kart Racing / 卡丁车", "Drift / 漂移"],
  "Card & Board / 卡牌桌游": ["CCG / 收藏式卡牌", "TCG / 集换式卡牌", "Deck-building / 牌组构筑", "Chess / 棋类", "Mahjong / 麻将", "Poker / 扑克", "Dice / 骰子", "Tabletop / 桌面游戏"],
  "Casino / 博彩类": ["Slots / 老虎机", "Bingo / 宾果", "Blackjack / 二十一点", "Roulette / 轮盘", "Poker-based / 扑克玩法", "Social Casino / 社交博彩"],
  "Music & Rhythm / 音乐节奏": ["Rhythm / 节奏", "Dance / 舞蹈", "Instrument / 乐器", "Karaoke / 卡拉 OK", "Beat Matching / 节拍匹配"],
  "Social & Party / 社交派对": ["Party Game / 派对游戏", "Werewolf / 狼人杀", "Voice Social / 语音社交", "UGC Community / UGC 社区", "Mini Games / 小游戏合集", "Asymmetric Party / 非对称派对"],
  "Educational / 教育": ["Kids / 儿童", "Language / 语言学习", "Learning / 学习", "Math / 数学", "Science / 科学", "Quiz Learning / 问答学习"],
  "Hybrid-casual / 混合休闲": ["Merge + Meta / 合成 + Meta", "Puzzle + RPG / 解谜 + RPG", "Runner + Upgrade / 跑酷 + 升级", "Arcade + Collection / 街机 + 收集", "Idle + Collection / 放置 + 收集"],
  "Other / 其他": ["Other / 其他", "Unclassified / 未分类"],
};

function inferPrimaryCategory(game) {
  const c = game.category || "";
  return Object.keys(GAME_CATEGORY_TREE).find(k => c.includes(k.split(" /")[0]) || c.includes(k.split(" / ")[1] || "")) || "RPG / 角色扮演";
}

function renderSubcategoryOptions(primary, game) {
  const selectedText = game?.category || "";
  const items = GAME_CATEGORY_TREE[primary] || [];
  return items.map(c => {
    const en = c.split(" / ")[0];
    const zh = c.split(" / ")[1] || "";
    return `
    <label class="flex items-center gap-1.5 px-3 py-2 border border-ink-200 rounded-lg cursor-pointer hover:border-brand-300 hover:bg-brand-50/30 transition">
      <input type="checkbox" name="subcategory" class="text-brand-500" ${selectedText.includes(en) || selectedText.includes(zh) ? "checked" : ""} />
      <span class="text-xs"><span class="font-medium text-ink-800">${en}</span><span class="text-ink-400"> / ${zh}</span></span>
    </label>
  `;
  }).join("");
}

window.updateSubcategories = function (primary, gameId) {
  const game = MOCK.GAMES.find(g => g.id === gameId) || {};
  const wrap = document.getElementById("subcategory-options");
  const hint = document.getElementById("subcategory-hint");
  if (wrap) wrap.innerHTML = renderSubcategoryOptions(primary, game);
  if (hint) hint.textContent = `当前一级品类：${primary}，已加载 ${GAME_CATEGORY_TREE[primary]?.length || 0} 个二级子类`;
};

function dismissGameCreatedDetailOverlay() {
  const overlay = document.getElementById("game-created-detail-overlay");
  if (!overlay) return;
  overlay.classList.add("opacity-0");
  setTimeout(() => overlay.remove(), 180);
}

window.dismissGameCreatedDetailOverlay = dismissGameCreatedDetailOverlay;

function highlightEmptyGameBasicFields() {
  const root = document.getElementById("page");
  if (!root) return;
  const fields = Array.from(root.querySelectorAll("input:not([type='radio']):not([type='checkbox']), textarea, select"))
    .filter((el) => !el.disabled && !el.readOnly);
  let firstEmpty = null;
  fields.forEach((el) => {
    const value = String(el.value || "").trim();
    const isEmpty = !value || value === "—";
    if (!isEmpty) return;
    el.classList.add("border-amber-400", "bg-amber-50", "ring-2", "ring-amber-100");
    el.setAttribute("data-highlight-empty", "1");
    if (!firstEmpty) firstEmpty = el;
    const clearHighlight = () => {
      if (String(el.value || "").trim()) {
        el.classList.remove("border-amber-400", "bg-amber-50", "ring-2", "ring-amber-100");
        el.removeAttribute("data-highlight-empty");
      }
    };
    el.addEventListener("input", clearHighlight);
    el.addEventListener("change", clearHighlight);
  });
  if (firstEmpty) {
    firstEmpty.scrollIntoView({ block: "center", behavior: "smooth" });
    setTimeout(() => firstEmpty.focus({ preventScroll: true }), 220);
    UI.toast("已高亮基本信息中待完善的字段", "info");
  } else {
    UI.toast("基本信息已填写完整", "success");
  }
}

window.highlightEmptyGameBasicFields = highlightEmptyGameBasicFields;

function continueCompleteGameBasicInfo(gameId) {
  dismissGameCreatedDetailOverlay();
  const path = location.hash.replace(/^#/, "") || "/";
  if (path.includes("?tab=") && !path.includes("?tab=basic")) {
    sessionStorage.setItem(`easyshare:highlightBasicEmpty:${gameId}`, "1");
    navigate(`/dev/games/${gameId}?tab=basic`);
    return;
  }
  highlightEmptyGameBasicFields();
}

window.continueCompleteGameBasicInfo = continueCompleteGameBasicInfo;

function showGameCreatedDetailOverlay(game) {
  document.getElementById("game-created-detail-overlay")?.remove();
  const html = `
    <div id="game-created-detail-overlay" class="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/20 backdrop-blur-[1px] transition-opacity duration-200">
      <div class="w-[520px] rounded-2xl bg-white border border-ok-200 shadow-pop overflow-hidden animate-fade-up relative">
        <button onclick="dismissGameCreatedDetailOverlay()" class="absolute right-3 top-3 w-8 h-8 rounded-lg hover:bg-ink-50 text-ink-400 flex items-center justify-center text-lg" aria-label="关闭">×</button>
        <div class="h-1 bg-gradient-to-r from-ok-500 via-brand-500 to-brand-900"></div>
        <div class="p-5 pr-12">
          <div class="flex items-start gap-3">
            <div class="w-11 h-11 rounded-full bg-ok-50 border border-ok-200 flex items-center justify-center flex-shrink-0">
              ${Icon.check({ size: 22, color: "#15803D", stroke: 2.6 })}
            </div>
            <div class="flex-1 min-w-0">
              <div class="text-base font-semibold text-ink-900">游戏已创建成功</div>
              <div class="text-sm text-ink-600 mt-1 leading-relaxed">${game.name} 已进入游戏详情页。运营人员可以在当前页面继续完善基本信息、品牌资源、团队成员和 API 接入配置。</div>
              <div class="mt-3 flex items-center gap-2 text-xs text-ink-500">
                <span class="badge bg-brand-50 text-brand-700">GameID</span>
                <code class="font-mono text-ink-700">${game.id}</code>
              </div>
            </div>
          </div>
          <div class="mt-4 flex items-center justify-end gap-3">
            <div class="flex gap-2">
              <button onclick="dismissGameCreatedDetailOverlay()" class="px-3 py-1.5 text-sm border border-ink-200 rounded-lg hover:bg-ink-50">知道了</button>
              <button onclick="continueCompleteGameBasicInfo('${game.id}')" class="px-3 py-1.5 text-sm bg-brand-900 text-white rounded-lg hover:bg-brand-800">继续完善信息</button>
            </div>
          </div>
        </div>
      </div>
    </div>`;
  document.body.insertAdjacentHTML("beforeend", html);
}

Pages.gameEdit = function (gameId) {
  const game = MOCK.GAMES.find((g) => g.id === gameId);
  if (!game) {
    return UI.emptyState({
      icon: "🔍",
      title: "游戏不存在",
      action: UI.primaryBtn("返回列表", { onclick: "navigate('/dev/games')" }),
    });
  }

  const tab = (location.hash.split("?tab=")[1] || "basic").split("&")[0];
  const tabs = [
    { key: "basic",    label: "基本信息",       icon: "ℹ️" },
    { key: "brand",    label: "品牌资源",       icon: "🎨" },
    { key: "packages", label: "游戏包体",       icon: "📦" },
    { key: "members",  label: "团队成员",       icon: "👥" },
    { key: "api",      label: "API 接入",       icon: "🔑" },
  ];

  const createdOverlayKey = `easyshare:gameCreatedDetailOverlay:${gameId}`;
  if (sessionStorage.getItem(createdOverlayKey) === "1") {
    window.PageHooks = window.PageHooks || {};
    const previousMounted = window.PageHooks.mounted;
    window.PageHooks.mounted = (path) => {
      if (typeof previousMounted === "function") previousMounted(path);
      showGameCreatedDetailOverlay(game);
      sessionStorage.removeItem(createdOverlayKey);
    };
  }

  const highlightBasicKey = `easyshare:highlightBasicEmpty:${gameId}`;
  if (tab === "basic" && sessionStorage.getItem(highlightBasicKey) === "1") {
    window.PageHooks = window.PageHooks || {};
    const previousMounted = window.PageHooks.mounted;
    window.PageHooks.mounted = (path) => {
      if (typeof previousMounted === "function") previousMounted(path);
      highlightEmptyGameBasicFields();
      sessionStorage.removeItem(highlightBasicKey);
    };
  }

  // 让顶部 hero 简洁版（不像详情页那么大）
  return `
    <!-- Hero（简化版） -->
    <div class="relative overflow-hidden rounded-2xl p-5 mb-4 bg-white border border-ink-200 shadow-soft">
      <div class="absolute -right-8 -top-8 w-32 h-32 rounded-full bg-brand-50"></div>
      <div class="absolute -right-12 -bottom-8 w-32 h-32 rounded-full bg-ink-50"></div>
      <div class="relative flex items-center gap-4">
        <div class="w-14 h-14 rounded-2xl bg-brand-50 border border-brand-100 flex items-center justify-center text-3xl flex-shrink-0">${game.icon}</div>
        <div class="flex-1">
          <div class="text-[10px] text-ink-500 uppercase tracking-wider font-semibold">编辑游戏</div>
          <div class="flex items-center gap-2 mt-0.5">
            <h1 class="text-xl font-extrabold tracking-tight text-ink-900">${game.name}</h1>
            <span class="badge bg-ok-50 text-ok-700 border border-ok-100">${game.status === "active" || game.status === "stable" ? "🟢 稳定运营" : game.status === "launch" ? "🔵 发行初期" : game.status === "draft" ? "⚪ 筹备中" : game.status === "paused" ? "🟠 暂停" : "⚫ 归档"}</span>
          </div>
          <div class="text-xs text-ink-500 mt-1">代码：<code class="px-1.5 py-0.5 bg-ink-100 text-ink-800 rounded font-mono">${game.code}</code> · ID: <code class="px-1.5 py-0.5 bg-brand-50 text-brand-800 rounded font-mono">${game.id}</code></div>
        </div>
        <div class="flex gap-2 flex-shrink-0">
          <button onclick="navigate('/dev/games/${gameId}')" class="px-3 py-1.5 text-sm bg-white border border-ink-200 text-ink-700 hover:bg-ink-50 rounded-xl">取消</button>
          <button onclick="confirmAction('保存修改', '确定要保存当前游戏信息的所有修改吗？保存后将立即影响后台展示与部分 SDK 配置。', '确认保存', '已保存所有修改', '/dev/games/${gameId}')" class="px-4 py-1.5 text-sm bg-brand-900 text-white hover:bg-brand-800 rounded-xl font-semibold flex items-center gap-1.5">
            <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M5 13l4 4L19 7"/></svg>
            保存修改
          </button>
        </div>
      </div>
    </div>

    <!-- 主内容：左 Tab 导航 + 右内容 -->
    <div class="grid grid-cols-[200px_1fr] gap-4">
      <!-- Tab 侧栏 -->
      <div class="card p-2 self-start sticky top-2">
        ${tabs.map(t => {
          const active = tab === t.key;
          const danger = t.color === "rose";
          return `
            <a href="#/dev/games/${gameId}/edit?tab=${t.key}" class="flex items-center gap-2.5 px-3 py-2.5 rounded-lg ${
              active
                ? (danger ? "bg-rose-50 text-rose-700 font-semibold" : "bg-brand-50 text-brand-700 font-semibold")
                : "text-ink-700 hover:bg-ink-50"
            } transition">
              <span class="text-base w-5 text-center">${t.icon}</span>
              <span class="text-[13px]">${t.label}</span>
              ${active ? `<span class="ml-auto w-1.5 h-1.5 rounded-full ${danger ? "bg-rose-500" : "bg-brand-500"} animate-pulse-soft"></span>` : ""}
            </a>
          `;
        }).join("")}
      </div>

      <!-- 内容区 -->
      <div>
        ${renderGameEditTab(tab, game)}
      </div>
    </div>
  `;
};

// ============================================================
// 各 Tab 内容
// ============================================================
function renderGameEditTab(tab, game) {
  if (tab === "basic")    return tabBasic(game);
  if (tab === "brand")    return tabBrand(game);
  if (tab === "packages") return tabPackages(game);
  if (tab === "members")  return tabMembers(game);
  if (tab === "api")      return tabApi(game);
  return tabBasic(game);
}

// ---------- Tab 1: 基本信息 ----------
function tabBasic(game) {
  const primaryCategory = inferPrimaryCategory(game);
  return `
    <div class="card p-6">
      <div class="mb-5">
        <h2 class="text-base font-bold text-ink-900">基本信息</h2>
        <p class="text-xs text-ink-500 mt-1">游戏的核心标识信息，影响 SDK 接入与运营展示</p>
      </div>

      <div class="space-y-5">
        ${editField("游戏名称", `
          <div class="grid grid-cols-2 gap-3">
            <div>
              <div class="text-xs text-ink-500 mb-1">中文名</div>
              <input type="text" value="${game.name_zh || game.name}" class="w-full px-3 py-2.5 border border-ink-200 rounded-xl outline-none focus:border-brand-500 focus:ring-2 focus:ring-brand-100 text-sm" />
            </div>
            <div>
              <div class="text-xs text-ink-500 mb-1">英文名</div>
              <input type="text" value="${game.name_en || game.code}" class="w-full px-3 py-2.5 border border-ink-200 rounded-xl outline-none focus:border-brand-500 focus:ring-2 focus:ring-brand-100 text-sm" />
            </div>
          </div>
        `, { required: true, help: "创建游戏时必须同时维护中文名和英文名；中文名用于内部识别，英文名用于海外展示与分享场景" })}

        ${editField("游戏代码（唯一标识） / Game ID", `
          <div class="grid grid-cols-2 gap-3">
            <div>
              <div class="flex items-center justify-between mb-1">
                <span class="text-xs text-ink-500">游戏代码</span>
                <span class="badge bg-amber-50 text-amber-700">🔒 已锁定</span>
              </div>
              <input type="text" value="${game.code}" disabled class="w-full px-3 py-2.5 border border-ink-200 rounded-xl bg-ink-50 text-ink-500 text-sm font-mono cursor-not-allowed" />
            </div>
            <div>
              <div class="flex items-center justify-between mb-1">
                <span class="text-xs text-ink-500">Game ID</span>
                <button onclick="copyText('${game.id}', 'Game ID ')" class="text-xs text-brand-700 hover:underline font-medium">复制</button>
              </div>
              <input type="text" value="${game.id}" readonly class="w-full px-3 py-2.5 border border-brand-200 rounded-xl bg-brand-50 text-brand-900 text-sm font-mono" />
            </div>
          </div>
          <div class="mt-2 px-3 py-2 bg-amber-50 border border-amber-200 rounded-lg text-xs text-amber-800 flex gap-2">
            <span>⚠️</span>
            <span>游戏代码与 Game ID 均为游戏级标识；同一款游戏下所有包体共用同一个 Game ID。游戏代码已被 <strong class="num">${MOCK.PACKAGES.filter(p => p.game_id === game.id).length}</strong> 个包体的 SDK 集成引用，修改需走变更审批流程。</span>
          </div>
        `)}

        ${editField("一级品类", `
          <select onchange="updateSubcategories(this.value, '${game.id}')" class="w-full px-3 py-2.5 border border-ink-200 rounded-xl text-sm bg-white">
            ${Object.keys(GAME_CATEGORY_TREE).map(o => `<option value="${o}" ${o === primaryCategory ? "selected" : ""}>${o}</option>`).join("")}
          </select>
        `)}

        ${editField("二级子类", `
          <div id="subcategory-options" class="grid grid-cols-4 gap-2">
            ${renderSubcategoryOptions(primaryCategory, game)}
          </div>
          <div id="subcategory-hint" class="text-xs text-ink-400 mt-1">当前一级品类：${primaryCategory}，已加载 ${GAME_CATEGORY_TREE[primaryCategory]?.length || 0} 个二级子类</div>
          <div class="text-xs text-ink-400 mt-1">可多选，用于后续渠道效果分析和模板推荐。</div>
        `)}

        ${editField("游戏描述", `
          <textarea rows="3" class="w-full px-3 py-2.5 border border-ink-200 rounded-xl text-sm outline-none focus:border-brand-500 focus:ring-2 focus:ring-brand-100">${game.desc === "—" ? "" : game.desc}</textarea>
          <div class="text-xs text-ink-400 mt-1">将展示在游戏列表卡片，建议 50 字以内</div>
        `)}

        ${editField("发行状态", `
          <div class="grid grid-cols-5 gap-2">
            ${[
              { v: "draft",    label: "筹备中",    desc: "研发/联调阶段" },
              { v: "launch",   label: "发行初期",  desc: "刚上线观察期" },
              { v: "stable",   label: "稳定运营",  desc: "长期运营中" },
              { v: "paused",   label: "暂停",      desc: "临时停用" },
              { v: "archived", label: "归档",      desc: "不再维护" },
            ].map(s => {
              const checked = game.status === s.v || (game.status === "active" && s.v === "stable");
              return `
              <label class="block cursor-pointer">
                <input type="radio" name="status" class="peer sr-only" ${checked ? "checked" : ""} />
                <div class="border-2 border-ink-200 peer-checked:border-brand-500 peer-checked:bg-brand-50/40 rounded-xl p-3 hover:border-brand-300 transition">
                  <div class="text-sm font-semibold text-ink-900">${s.label}</div>
                  <div class="text-[11px] text-ink-500 mt-0.5">${s.desc}</div>
                </div>
              </label>
            `}).join("")}
          </div>
        `)}

      </div>
    </div>

    <!-- 元数据卡 -->
    <div class="card p-6 mt-4">
      <h3 class="text-sm font-bold text-ink-900 mb-4">元数据（只读）</h3>
      <div class="grid grid-cols-2 gap-x-12 gap-y-4">
        ${readonlyField("游戏 ID", `<code class="font-mono">${game.id}</code>`)}
        ${readonlyField("创建时间", "2024-01-15 10:23")}
        ${readonlyField("创建者", "李管理 (li.admin@easyshare.com)")}
        ${readonlyField("最后修改", "2026-05-15 17:32 · 张三")}
      </div>
    </div>
  `;
}

// ---------- Tab 2: 游戏包体 ----------
function tabPackages(game) {
  const packages = MOCK.PACKAGES.filter(p => p.game_id === game.id);
  const regionCount = new Set(packages.map(p => p.region).filter(Boolean)).size;
  const platformCount = new Set(packages.map(p => packagePlatformCode(p.platform)).filter(Boolean)).size;
  return `
    <div class="space-y-4">
      <div class="grid grid-cols-3 gap-3">
        <div class="card p-4">
          <div class="text-xs text-ink-500">包体数量</div>
          <div class="num text-2xl font-semibold text-ink-900 mt-1">${packages.length}</div>
          <div class="text-xs text-ink-400 mt-1">当前游戏下的 Region × Platform 包体</div>
        </div>
        <div class="card p-4">
          <div class="text-xs text-ink-500">覆盖区域</div>
          <div class="num text-2xl font-semibold text-ink-900 mt-1">${regionCount || 0}</div>
          <div class="text-xs text-ink-400 mt-1">按 Region / 国家区域统计</div>
        </div>
        <div class="card p-4">
          <div class="text-xs text-ink-500">平台类型</div>
          <div class="num text-2xl font-semibold text-ink-900 mt-1">${platformCount || 0}</div>
          <div class="text-xs text-ink-400 mt-1">App Store / Google Play / 三方平台</div>
        </div>
      </div>

      <div class="card overflow-hidden">
        <div class="px-5 py-4 border-b border-ink-100 flex items-center justify-between gap-3">
          <div>
            <h2 class="text-base font-bold text-ink-900">游戏包体</h2>
            <p class="text-xs text-ink-500 mt-1">维护该游戏下所有包体；包体共享游戏级 GameID 与 Game Secret，仅区分 Ripple ID、Region、Platform、App ID 与商店链接。</p>
          </div>
          <button onclick="navigate('/dev/games/${game.id}/packages/create')" class="px-3 py-1.5 text-sm bg-brand-900 text-white rounded-lg hover:bg-brand-800 font-medium flex items-center gap-1.5">
            ${Icon.plus({ size: 13, color: "#fff" })}
            添加包体
          </button>
        </div>
        <div class="p-4 space-y-2">
          ${packages.length ? packages.map(p => renderPackageRow(p)).join("") : `
            <div class="py-12 text-center">
              <div class="w-12 h-12 mx-auto rounded-2xl bg-ink-50 border border-ink-200 flex items-center justify-center mb-3">${Icon.package({ size: 22, color: "#64748B" })}</div>
              <div class="text-sm font-semibold text-ink-900">暂无包体</div>
              <div class="text-xs text-ink-500 mt-1">请先为该游戏创建至少一个 Region × Platform 包体。</div>
              <button onclick="navigate('/dev/games/${game.id}/packages/create')" class="mt-4 px-4 py-2 text-sm bg-brand-900 text-white rounded-lg hover:bg-brand-800">添加第一个包体</button>
            </div>
          `}
        </div>
      </div>
    </div>
  `;
}

// ---------- Tab 3: 品牌资源 ----------
function tabBrand(game) {
  return `
    <div class="card p-6">
      <div class="mb-5">
        <h2 class="text-base font-bold text-ink-900">品牌资源</h2>
        <p class="text-xs text-ink-500 mt-1">游戏的视觉标识、默认分享图、品牌色，影响管理后台与分享卡片的展示</p>
      </div>

      <div class="space-y-6">
        <!-- 游戏图标 -->
        ${editField("游戏图标", `
          <div class="flex gap-6 items-start">
            <!-- 当前图标预览 -->
            <div class="text-center">
              <div id="edit-game-icon-preview" class="w-24 h-24 rounded-2xl bg-ink-100 flex items-center justify-center text-5xl shadow-soft overflow-hidden">${game.icon}</div>
              <div id="edit-game-icon-file-name" class="text-[10px] text-ink-400 mt-2">当前图标</div>
            </div>
            <!-- 预设 + 上传 -->
            <div class="flex-1">
              <div class="text-xs font-semibold text-ink-700 mb-2">选择预设</div>
              <div class="grid grid-cols-9 gap-2">
                ${["👑","🐉","🍬","⚔️","🏰","🚀","🎮","🎯","🃏","⚽️","🏎️","🎲","🛡️","🪄","🦸","🌌","💎","🔥"].map(e => `
                  <button class="w-9 h-9 rounded-lg border ${e === game.icon ? "border-brand-500 bg-brand-50 ring-2 ring-brand-100" : "border-ink-200 hover:border-brand-300"} flex items-center justify-center text-xl transition">${e}</button>
                `).join("")}
              </div>
              <div onclick="document.getElementById('edit-game-icon-file').click()" class="mt-3 border-2 border-dashed border-ink-200 rounded-xl p-4 text-center hover:border-brand-400 cursor-pointer transition">
                <div class="text-2xl">📷</div>
                <div class="text-xs text-ink-700 font-medium mt-1">或上传自定义图标（PNG / JPG / WebP · &lt;500KB）</div>
              </div>
              <input id="edit-game-icon-file" type="file" accept="image/png,image/jpeg,image/webp" class="hidden" onchange="handleEditGameIconFile(this.files?.[0])" />
            </div>
          </div>
        `)}

        <!-- 品牌色 -->
        ${editField("品牌色", `
          <div class="grid grid-cols-[320px_1fr] gap-5">
            <!-- 标准色卡：色域 + Hue 滑条 -->
            <div class="space-y-3">
              <div
                id="brand-sv-panel"
                class="relative h-48 rounded-xl border border-ink-200 overflow-hidden cursor-crosshair select-none"
                style="background: linear-gradient(to top, #000, transparent), linear-gradient(to right, #fff, hsl(220, 100%, 50%));"
                onmousedown="startBrandColorDrag(event)"
              >
                <div id="brand-sv-thumb" class="absolute w-4 h-4 rounded-full border-2 border-white shadow-md ring-1 ring-ink-500 pointer-events-none" style="left: 70%; top: 35%; transform: translate(-50%, -50%);"></div>
              </div>
              <div>
                <label class="block text-xs text-ink-500 mb-1">色相 Hue</label>
                <div
                  id="brand-hue-bar"
                  class="relative h-3 rounded-full border border-ink-200 cursor-pointer select-none"
                  style="background: linear-gradient(to right, red, yellow, lime, cyan, blue, magenta, red);"
                  onmousedown="startBrandHueDrag(event)"
                >
                  <div
                    id="brand-hue-thumb"
                    class="absolute top-1/2 w-4 h-4 rounded-full border-2 border-white shadow-md ring-1 ring-ink-500 bg-white pointer-events-none"
                    style="left: 61.1%; transform: translate(-50%, -50%);"
                  ></div>
                </div>
              </div>
              <div class="flex items-center gap-2 text-[11px] text-ink-400">
                <span>在色域中按住鼠标拖动选择明度 / 饱和度</span>
              </div>
            </div>

            <!-- 右侧：输入与预览 -->
            <div class="min-w-0">
              <div class="grid grid-cols-[1fr_120px] gap-3">
                <div>
                  <label class="block text-xs text-ink-500 mb-1">品牌色值</label>
                  <input
                    id="brand-color-hex"
                    type="text"
                    value="#1E3A8A"
                    maxlength="7"
                    class="w-full px-3 py-2.5 border border-ink-200 rounded-lg text-sm font-mono outline-none focus:border-brand-500 focus:ring-2 focus:ring-brand-100"
                    placeholder="#1E3A8A"
                    oninput="syncBrandColor(this.value, 'hex')"
                  />
                </div>
                <div>
                  <label class="block text-xs text-ink-500 mb-1">预览</label>
                  <div id="brand-color-preview" class="h-[42px] rounded-lg border border-ink-200" style="background:#1E3A8A"></div>
                </div>
              </div>
              <div class="mt-3 rounded-lg border border-ink-200 overflow-hidden">
                <div id="brand-color-sample" class="h-10 flex items-center px-3 text-white text-xs font-semibold" style="background:#1E3A8A">
                  ${game.name} · 分享卡片主色预览
                </div>
                <div class="px-3 py-2 bg-white text-xs text-ink-500">
                  品牌色用于管理后台重点按钮、分享卡片主色、渠道素材默认强调色等位置。
                </div>
              </div>
              <div class="mt-3 grid grid-cols-3 gap-2 text-xs">
                <div class="bg-ink-50 border border-ink-200 rounded-lg p-2">
                  <div class="text-ink-400">Hue</div>
                  <div id="brand-h-value" class="font-mono font-semibold text-ink-900">220°</div>
                </div>
                <div class="bg-ink-50 border border-ink-200 rounded-lg p-2">
                  <div class="text-ink-400">Saturation</div>
                  <div id="brand-s-value" class="font-mono font-semibold text-ink-900">70%</div>
                </div>
                <div class="bg-ink-50 border border-ink-200 rounded-lg p-2">
                  <div class="text-ink-400">Brightness</div>
                  <div id="brand-v-value" class="font-mono font-semibold text-ink-900">65%</div>
                </div>
              </div>
            </div>
          </div>
        `)}

        <!-- 默认分享图 -->
        ${editField("默认分享图（fallback image）", `
          <div class="flex gap-4">
            <div id="share-image-preview" class="w-64 aspect-[1200/630] rounded-xl border-2 border-dashed border-ink-200 flex items-center justify-center bg-ink-100 text-6xl overflow-hidden">${game.icon}</div>
            <div class="flex-1 space-y-3">
              <div onclick="document.getElementById('share-image-file').click()" class="border-2 border-dashed border-ink-200 rounded-xl p-5 text-center hover:border-brand-400 cursor-pointer transition">
                <div class="text-3xl">🖼️</div>
                <div class="text-sm font-medium text-ink-700 mt-1">上传新分享图</div>
                <div id="share-image-file-name" class="text-xs text-ink-400 mt-0.5">建议 1200×630 px · PNG / JPG / WebP · &lt; 1MB</div>
              </div>
              <input id="share-image-file" type="file" accept="image/png,image/jpeg,image/webp" class="hidden" onchange="handleShareImageFile(this.files?.[0])" />
              <div class="px-3 py-2 bg-amber-50 border border-amber-200 rounded-lg text-xs text-amber-800 flex gap-2">
                <span>⚠️</span>
                <span>当某个包体未单独配置分享图时，将使用此默认图。修改后 Facebook / WhatsApp crawler 缓存最长 24h 才刷新。</span>
              </div>
            </div>
          </div>
        `)}

        <!-- 官方链接 -->
        ${editField("官方链接", `
          <div class="space-y-2">
            ${[
              { label: "官网", icon: "🌐", val: "https://kingsquest.com" },
              { label: "客服邮箱", icon: "📧", val: "support@kingsquest.com" },
              { label: "Discord 服务器", icon: "🎮", val: "https://discord.gg/kingsquest" },
            ].map(l => `
              <div class="flex items-center gap-2">
                <span class="w-24 text-xs text-ink-500 flex items-center gap-1.5"><span>${l.icon}</span>${l.label}</span>
                <input type="text" value="${l.val}" class="flex-1 px-3 py-2 border border-ink-200 rounded-lg text-sm font-mono outline-none focus:border-brand-500" />
              </div>
            `).join("")}
          </div>
        `)}
      </div>
    </div>
  `;
}

// ---------- Tab 3: 团队成员 ----------
function tabMembers(game) {
  // 单游戏团队成员页只展示游戏级角色：游戏运营 / 游戏研发。
  // SDK 管理员是平台级角色，不在单款游戏下展示或管理。
  window.__memberFilter = window.__memberFilter || "all";
  const currentFilter = window.__memberFilter;
  const gameMembers = MOCK.USERS.filter(u => u.games.includes(game.id) && u.role !== "sdk_admin");
  const operators = gameMembers.filter(u => u.role === "operator");
  const developers = gameMembers.filter(u => u.role === "developer");
  const displayMembers = currentFilter === "operator" ? operators : currentFilter === "developer" ? developers : gameMembers;
  const filterBtn = (key, label) => `
    <button onclick="setMemberFilter('${key}')" class="px-2.5 py-1 border rounded-md ${currentFilter === key ? "border-brand-700 bg-brand-50 text-brand-700 font-medium" : "border-ink-200 hover:bg-ink-50 text-ink-600"}">${label}</button>
  `;

  const roleBadge = (role) => {
    if (role === "operator") return `<span class="badge bg-brand-50 text-brand-700 border border-brand-100">游戏运营</span>`;
    if (role === "developer") return `<span class="badge bg-ok-50 text-ok-700 border border-ok-100">游戏研发</span>`;
    return `<span class="badge bg-danger-50 text-danger-700 border border-danger-100">SDK 管理员</span>`;
  };

  return `
    <div class="card p-6">
      <div class="flex items-center justify-between mb-5">
        <div>
          <h2 class="text-base font-bold text-ink-900">团队成员</h2>
          <p class="text-xs text-ink-500 mt-1">管理 <strong>${game.name}</strong> 下的游戏研发与游戏运营授权。</p>
        </div>
        ${UI.primaryBtn("+ 添加游戏成员", { onclick: `openAddGameMemberModal('${game.id}', '${game.name}')` })}
      </div>

      <!-- 游戏级角色统计 -->
      <div class="grid grid-cols-2 gap-3 mb-5">
        <div class="rounded-xl p-4 bg-brand-50 border border-brand-100">
          <div class="flex items-center justify-between">
            <span class="text-xs font-semibold text-brand-700">游戏级</span>
            <span class="num text-2xl font-bold text-brand-700">${operators.length}</span>
          </div>
          <div class="text-sm font-semibold text-ink-900 mt-2">游戏运营</div>
          <div class="text-[11px] text-ink-600 mt-1">拥有运营管理权限：分享配置、模板、分享管理、数据分析。</div>
        </div>
        <div class="rounded-xl p-4 bg-ok-50 border border-ok-100">
          <div class="flex items-center justify-between">
            <span class="text-xs font-semibold text-ok-700">游戏级</span>
            <span class="num text-2xl font-bold text-ok-700">${developers.length}</span>
          </div>
          <div class="text-sm font-semibold text-ink-900 mt-2">游戏研发</div>
          <div class="text-[11px] text-ink-600 mt-1">拥有研发工具权限：游戏管理、包体管理、SDK 监控、SDK 文档。</div>
        </div>
      </div>

      <!-- 本游戏授权成员 -->
      <div class="mb-5">
        <div class="flex items-center justify-between mb-2">
          <div>
            <h3 class="text-sm font-semibold text-ink-900">本游戏授权成员</h3>
            <p class="text-[11px] text-ink-500 mt-0.5">这里只管理游戏级角色：游戏研发 / 游戏运营。</p>
          </div>
          <div class="flex gap-2 text-xs">
            ${filterBtn("all", "全部")}
            ${filterBtn("operator", "仅看运营")}
            ${filterBtn("developer", "仅看研发")}
          </div>
        </div>
        <div class="overflow-hidden border border-ink-100 rounded-xl">
          <table class="w-full text-sm">
            <thead class="bg-ink-50 text-xs text-ink-500">
              <tr>
                <th class="text-left px-4 py-3 font-semibold">成员</th>
                <th class="text-left px-4 py-3 font-semibold">邮箱</th>
                <th class="text-left px-4 py-3 font-semibold">游戏级角色</th>
                <th class="text-left px-4 py-3 font-semibold">权限范围</th>
                <th class="text-left px-4 py-3 font-semibold">最近活跃</th>
                <th class="text-right px-4 py-3 font-semibold">操作</th>
              </tr>
            </thead>
            <tbody>
              ${displayMembers.length ? displayMembers.map(u => {
                const scope = u.role === "operator" ? "运营管理" : "研发工具";
                return `
                  <tr class="border-t border-ink-100 row-hover">
                    <td class="px-4 py-3">
                      <div class="flex items-center gap-2.5">
                        <div class="w-8 h-8 rounded-lg bg-brand-900 flex items-center justify-center text-white text-xs font-bold">${u.name[0]}</div>
                        <div class="font-semibold text-ink-900">${u.name}</div>
                      </div>
                    </td>
                    <td class="px-4 py-3 text-xs text-ink-500 font-mono">${u.email}</td>
                    <td class="px-4 py-3">${roleBadge(u.role)}</td>
                    <td class="px-4 py-3"><span class="text-xs px-2 py-0.5 rounded bg-ink-100 text-ink-700">${scope}</span></td>
                    <td class="px-4 py-3 text-xs text-ink-500">${u.lastActive}</td>
                    <td class="px-4 py-3 text-right">
                      <button onclick="openChangeMemberRoleModal('${u.id}', '${game.id}')" class="text-xs text-brand-700 hover:underline mr-2 font-medium">变更角色</button>
                      <button onclick="UI.confirmModal({title:'移除成员',content:'确定移除 <strong>${u.name}</strong> 对本游戏的访问权限？',confirmText:'确认移除',onConfirm:()=>UI.toast('已移除','success')})" class="text-xs text-rose-500 hover:underline">移除</button>
                    </td>
                  </tr>
                `;
              }).join("") : `
                <tr class="border-t border-ink-100">
                  <td colspan="6" class="px-4 py-10 text-center text-sm text-ink-400">当前筛选条件下暂无成员</td>
                </tr>
              `}
            </tbody>
          </table>
        </div>
      </div>

    </div>
  `;
}

// ---------- Tab 4: API 密钥 ----------
function tabApi(game) {
  const gameSecret = `gs_live_${game.id.replace(/[^a-z0-9]/gi, "").padEnd(16, "0")}************`;
  return `
    <div class="card p-6">
      <div class="mb-5">
        <h2 class="text-base font-bold text-ink-900">API 接入</h2>
        <p class="text-xs text-ink-500 mt-1">研发工具中只展示接入所需信息与 Webhook 联调；密钥重置、禁用、删除等管理员操作请到「管理员功能」处理。</p>
      </div>

      <!-- 游戏级凭证（只读） -->
      <div class="mb-6">
        <div class="flex items-center justify-between mb-3">
          <h3 class="text-sm font-semibold text-ink-900 flex items-center gap-2">🔑 游戏级凭证</h3>
          <span class="text-[10px] text-ink-400">同一游戏下所有包体共享</span>
        </div>
        <div class="grid grid-cols-2 gap-3">
          <div class="border border-ink-100 rounded-xl p-4">
            <div class="flex items-center justify-between mb-2">
              <span class="badge bg-brand-50 text-brand-700">Game ID · 公开</span>
              <button onclick="copyText('${game.id}', 'Game ID ')" class="text-xs text-brand-700 hover:underline font-medium">复制</button>
            </div>
            <code class="block px-3 py-2 bg-ink-50 rounded-lg text-xs font-mono text-ink-700 break-all">${game.id}</code>
            <p class="text-[11px] text-ink-500 mt-2">客户端 SDK 初始化使用，可前端明文。</p>
          </div>
          <div class="border border-warn-200 rounded-xl p-4">
            <div class="flex items-center justify-between mb-2">
              <span class="badge bg-warn-50 text-warn-700">Game Secret · 机密</span>
              <span class="text-[10px] text-ink-400">只读</span>
            </div>
            <code class="block px-3 py-2 bg-warn-50 rounded-lg text-xs font-mono text-warn-800 break-all">${gameSecret}</code>
            <p class="text-[11px] text-ink-500 mt-2">服务端签名使用，不要放入客户端。重置请到「管理员功能 → 游戏全局管理」。</p>
          </div>
        </div>
      </div>

      <!-- 服务端 OpenAPI 密钥（只读查看） -->
      <div class="mb-6">
        <div class="flex items-center justify-between mb-3">
          <h3 class="text-sm font-semibold text-ink-900 flex items-center gap-2">🔐 服务端 OpenAPI 密钥</h3>
          <span class="text-[10px] text-ink-400">创建 / 禁用请到管理员功能</span>
        </div>
        <div class="overflow-hidden border border-ink-100 rounded-xl">
          <table class="w-full text-sm">
            <thead class="bg-ink-50 text-xs text-ink-500">
              <tr>
                <th class="text-left px-4 py-2.5 font-semibold">名称</th>
                <th class="text-left px-4 py-2.5 font-semibold">权限</th>
                <th class="text-left px-4 py-2.5 font-semibold">App Key</th>
                <th class="text-left px-4 py-2.5 font-semibold">最近使用</th>
                <th class="text-right px-4 py-2.5 font-semibold">操作</th>
              </tr>
            </thead>
            <tbody>
              ${[
                { name: "事件上报密钥", perm: "events:write", key: "es_evt_8a2f9c…", fullKey: "es_evt_8a2f9c1b3d4e5f6a7b8c9d0e", lastUsed: "2 分钟前" },
                { name: "数据读取密钥", perm: "analytics:read, config:read", key: "es_rd_4c1e7a…", fullKey: "es_rd_4c1e7a2b9f3d8a5b1c2d3e4f", lastUsed: "1 小时前" },
              ].map(k => `
                <tr class="border-t border-ink-100 row-hover">
                  <td class="px-4 py-2.5 font-medium">${k.name}</td>
                  <td class="px-4 py-2.5 text-xs text-ink-500"><code class="font-mono">${k.perm}</code></td>
                  <td class="px-4 py-2.5"><code class="font-mono text-xs px-2 py-0.5 bg-ink-50 rounded">${k.key}</code></td>
                  <td class="px-4 py-2.5 text-xs text-ink-500">${k.lastUsed}</td>
                  <td class="px-4 py-2.5 text-right">
                    <button onclick="openViewApiKeyModal('${k.name}', '${k.fullKey}', '${k.perm}')" class="text-xs text-brand-700 hover:underline">查看</button>
                  </td>
                </tr>
              `).join("")}
            </tbody>
          </table>
        </div>
      </div>

      <!-- Webhook 回调（研发联调能力） -->
      <div>
        <div class="flex items-center justify-between mb-3">
          <h3 class="text-sm font-semibold text-ink-900 flex items-center gap-2">🔔 Webhook 回调地址</h3>
          <span class="text-[10px] text-ink-400">分享 / 归因事件实时推送 · 可联调测试</span>
        </div>
        <div class="space-y-2">
          ${[
            { id: "share", event: "分享成功", url: "https://api.kingsquest.com/easyshare/share", enabled: true },
            { id: "attr", event: "归因匹配", url: "https://api.kingsquest.com/easyshare/attribution", enabled: true },
            { id: "purchase", event: "付费事件", url: "", enabled: false, placeholder: "https://your.server/purchase" },
          ].map(w => `
            <div class="flex items-center gap-2">
              <span class="w-24 text-xs text-ink-500">${w.event}</span>
              <input id="webhook-${w.id}" type="url" value="${w.url}" placeholder="${w.placeholder || ""}" class="flex-1 px-3 py-2 border border-ink-200 rounded-lg text-sm font-mono outline-none focus:border-brand-500" />
              <label class="relative inline-flex items-center cursor-pointer" title="启用/停用回调">
                <input type="checkbox" ${w.enabled ? "checked" : ""} onchange="toggleWebhook('${w.event}', this.checked)" class="sr-only peer" />
                <div class="w-10 h-5 bg-ink-200 peer-checked:bg-brand-500 rounded-full transition relative">
                  <div class="absolute top-0.5 left-0.5 w-4 h-4 bg-white rounded-full peer-checked:translate-x-5 transition shadow"></div>
                </div>
              </label>
              <button onclick="testWebhook('${w.id}', '${w.event}')" class="px-2 py-1 text-xs text-ink-500 hover:bg-ink-50 rounded">🧪 测试</button>
            </div>
          `).join("")}
        </div>
      </div>
    </div>
  `;
}

// ---------- Tab 5: 危险区域 ----------
function tabDanger(game) {
  const canPermanentDelete = MOCK.SESSION.currentRole === "sdk_admin";
  return `
    <div class="card p-6 border-2 border-rose-200">
      <div class="flex items-center gap-2 mb-1">
        <div class="w-10 h-10 rounded-xl bg-danger-600 text-white flex items-center justify-center text-base shadow-soft">⚠️</div>
        <div>
          <h2 class="text-base font-bold text-rose-700">危险区域</h2>
          <p class="text-xs text-rose-600 mt-0.5">这些操作不可恢复，请谨慎确认</p>
        </div>
      </div>

      <div class="mt-5 space-y-3">
        ${dangerRow({
          title: "暂停游戏",
          desc: "暂停后所有 SDK 调用将被拒绝，分享不再生效；可随时恢复",
          btn: "暂停游戏",
          btnClass: "bg-amber-50 text-amber-700 hover:bg-amber-100 border-amber-200",
          confirm: `UI.confirmModal({title:'暂停游戏',content:'暂停后所有 SDK 调用将被拒绝，确定继续？',confirmText:'确认暂停',onConfirm:()=>UI.toast('游戏已暂停','warning')})`,
        })}

        ${dangerRow({
          title: "归档游戏",
          desc: "归档后游戏将从主列表移除，但保留所有历史数据；可在『已归档』中恢复",
          btn: "归档游戏",
          btnClass: "bg-ink-50 text-ink-700 hover:bg-ink-100 border-ink-200",
          confirm: `UI.confirmModal({title:'归档游戏',content:'确定将 <strong>${game.name}</strong> 归档？归档后将从游戏列表中隐藏。',confirmText:'确认归档',onConfirm:()=>UI.toast('游戏已归档','info')})`,
        })}

        ${dangerRow({
          title: "转移游戏所有权",
          desc: "将此游戏的管理权移交给另一个 SDK 管理员；当前管理员将失去访问权限",
          btn: "转移所有权",
          btnClass: "bg-ink-50 text-ink-700 hover:bg-ink-100 border-ink-200",
          confirm: `UI.toast('请联系平台管理员发起转移', 'info')`,
        })}

        ${canPermanentDelete ? `
        <!-- 永久删除（仅 SDK 管理员可见） -->
        <div class="border-2 border-rose-300 bg-rose-50/60 rounded-2xl p-5">
          <div class="flex items-start gap-3">
            <span class="w-9 h-9 rounded-xl bg-danger-700 text-white flex items-center justify-center text-base flex-shrink-0">💀</span>
            <div class="flex-1">
              <div class="text-sm font-bold text-rose-700">永久删除游戏</div>
              <div class="text-xs text-rose-600 mt-1 leading-relaxed">将删除此游戏的所有数据，包括 ${MOCK.PACKAGES.filter(p => p.game_id === game.id).length} 个包体、所有分享配置、历史漏斗数据、用户路径数据。<strong>此操作不可恢复。</strong></div>
              <ul class="text-[11px] text-rose-700 mt-2 space-y-0.5 list-disc ml-4">
                <li>所有 SDK 接入将立即失效</li>
                <li>历史事件日志保留 7 天后彻底删除</li>
                <li>团队成员将失去对此游戏的访问</li>
                <li>API 密钥将被立即禁用</li>
              </ul>
            </div>
            <button onclick="openDeleteGameModal('${game.id}', '${game.name}')" class="px-4 py-2 text-sm bg-danger-600 text-white rounded-xl font-semibold shadow-soft hover:shadow-soft flex-shrink-0">
              永久删除
            </button>
          </div>
        </div>
        ` : ""}
      </div>
    </div>
  `;
}

// ---------- 辅助函数 ----------
function editField(label, content, opts = {}) {
  const { required = false, help = "" } = opts;
  return `
    <div>
      <label class="block text-sm font-semibold text-ink-700 mb-2">${label}${required ? '<span class="text-rose-500 ml-0.5">*</span>' : ""}</label>
      ${content}
      ${help ? `<div class="text-xs text-ink-400 mt-1">${help}</div>` : ""}
    </div>
  `;
}
function readonlyField(label, value) {
  return `
    <div>
      <div class="text-xs text-ink-500">${label}</div>
      <div class="text-sm mt-1 text-ink-900">${value}</div>
    </div>
  `;
}
function dangerRow({ title, desc, btn, btnClass, confirm }) {
  return `
    <div class="flex items-center justify-between gap-4 px-4 py-3.5 bg-white border border-ink-100 rounded-xl">
      <div class="flex-1 min-w-0">
        <div class="text-sm font-semibold text-ink-900">${title}</div>
        <div class="text-xs text-ink-500 mt-0.5">${desc}</div>
      </div>
      <button onclick="${confirm}" class="px-3 py-1.5 text-sm rounded-lg border ${btnClass} flex-shrink-0 font-medium">${btn}</button>
    </div>
  `;
}

// ---------- 删除游戏 Modal（需要输入游戏名确认） ----------
window.openDeleteGameModal = function (gameId, gameName) {
  if (MOCK.SESSION.currentRole !== "sdk_admin") {
    UI.toast("仅 SDK 管理员可以永久删除游戏", "error");
    return;
  }
  const html = `
    <div class="fixed inset-0 z-50 flex items-center justify-center" id="del-mask">
      <div class="absolute inset-0 bg-ink-900/60 backdrop-blur-sm"></div>
      <div class="relative bg-white rounded-2xl shadow-pop w-[480px] p-6 animate-fade-up border-2 border-rose-200">
        <div class="flex items-center gap-3 mb-4">
          <div class="w-12 h-12 rounded-2xl bg-danger-600 text-white flex items-center justify-center text-xl shadow-soft">💀</div>
          <div>
            <h3 class="text-lg font-bold text-rose-700">永久删除游戏</h3>
            <p class="text-xs text-rose-600">此操作不可恢复</p>
          </div>
        </div>
        <div class="bg-rose-50 border border-rose-200 rounded-xl p-3 text-xs text-rose-800 mb-4">
          删除 <strong>${gameName}</strong> 将立即销毁所有相关数据，包括包体、配置、漏斗、用户路径。
        </div>
        <label class="block text-sm text-ink-700 mb-2">请输入游戏名称 <code class="font-mono px-1.5 py-0.5 bg-ink-100 rounded text-rose-700">${gameName}</code> 以确认：</label>
        <input id="del-input" type="text" placeholder="${gameName}" class="w-full px-3 py-2.5 border-2 border-ink-200 rounded-xl outline-none focus:border-rose-500 focus:ring-2 focus:ring-rose-100 text-sm font-mono" oninput="
          document.getElementById('del-btn').disabled = this.value !== '${gameName}';
          document.getElementById('del-btn').className = this.value === '${gameName}'
            ? 'px-4 py-2 rounded-xl bg-danger-600 text-white text-sm font-semibold shadow-soft'
            : 'px-4 py-2 rounded-xl bg-ink-100 text-ink-300 text-sm font-semibold cursor-not-allowed';
        " />
        <div class="mt-5 flex justify-end gap-2">
          <button onclick="document.getElementById('del-mask').remove()" class="px-4 py-2 rounded-xl border border-ink-200 text-sm hover:bg-ink-50">取消</button>
          <button id="del-btn" disabled onclick="
            document.getElementById('del-mask').remove();
            UI.toast('游戏已永久删除', 'error');
            setTimeout(() => navigate('/dev/games'), 800);
          " class="px-4 py-2 rounded-xl bg-ink-100 text-ink-300 text-sm font-semibold cursor-not-allowed">永久删除</button>
        </div>
      </div>
    </div>
  `;
  document.body.insertAdjacentHTML("beforeend", html);
  setTimeout(() => document.getElementById("del-input")?.focus(), 100);
};

// ---------- 标准色卡同步：HSV 色域 + Hue 滑条 ----------
window.__brandHSV = window.__brandHSV || { h: 220, s: 70, v: 65 };

function hsvToHex(h, s, v) {
  s /= 100;
  v /= 100;
  const c = v * s;
  const x = c * (1 - Math.abs(((h / 60) % 2) - 1));
  const m = v - c;
  let r = 0, g = 0, b = 0;
  if (h < 60) [r, g, b] = [c, x, 0];
  else if (h < 120) [r, g, b] = [x, c, 0];
  else if (h < 180) [r, g, b] = [0, c, x];
  else if (h < 240) [r, g, b] = [0, x, c];
  else if (h < 300) [r, g, b] = [x, 0, c];
  else [r, g, b] = [c, 0, x];
  const toHex = (n) => Math.round((n + m) * 255).toString(16).padStart(2, "0");
  return `#${toHex(r)}${toHex(g)}${toHex(b)}`.toUpperCase();
}

function hexToRgb(hex) {
  const m = /^#?([0-9a-fA-F]{6})$/.exec(hex || "");
  if (!m) return null;
  const n = parseInt(m[1], 16);
  return { r: (n >> 16) & 255, g: (n >> 8) & 255, b: n & 255 };
}

function rgbToHsv(r, g, b) {
  r /= 255; g /= 255; b /= 255;
  const max = Math.max(r, g, b), min = Math.min(r, g, b);
  const d = max - min;
  let h = 0;
  if (d !== 0) {
    if (max === r) h = 60 * (((g - b) / d) % 6);
    else if (max === g) h = 60 * ((b - r) / d + 2);
    else h = 60 * ((r - g) / d + 4);
  }
  if (h < 0) h += 360;
  const s = max === 0 ? 0 : d / max;
  return { h: Math.round(h), s: Math.round(s * 100), v: Math.round(max * 100) };
}

function updateBrandColorUI(hex) {
  const state = window.__brandHSV;
  const sv = document.getElementById("brand-sv-panel");
  const thumb = document.getElementById("brand-sv-thumb");
  const hexInput = document.getElementById("brand-color-hex");
  const preview = document.getElementById("brand-color-preview");
  const sample = document.getElementById("brand-color-sample");
  const hueThumb = document.getElementById("brand-hue-thumb");

  if (sv) sv.style.background = `linear-gradient(to top, #000, transparent), linear-gradient(to right, #fff, hsl(${state.h}, 100%, 50%))`;
  if (thumb) {
    thumb.style.left = `${state.s}%`;
    thumb.style.top = `${100 - state.v}%`;
  }
  if (hexInput && hexInput.value.toUpperCase() !== hex) hexInput.value = hex;
  if (preview) preview.style.background = hex;
  if (sample) sample.style.background = hex;
  if (hueThumb) hueThumb.style.left = `${(state.h / 360) * 100}%`;

  const hv = document.getElementById("brand-h-value");
  const svv = document.getElementById("brand-s-value");
  const vv = document.getElementById("brand-v-value");
  if (hv) hv.textContent = `${state.h}°`;
  if (svv) svv.textContent = `${state.s}%`;
  if (vv) vv.textContent = `${state.v}%`;
}

window.setBrandHue = function (h) {
  window.__brandHSV.h = Math.max(0, Math.min(360, Number(h) || 0));
  updateBrandColorUI(hsvToHex(window.__brandHSV.h, window.__brandHSV.s, window.__brandHSV.v));
};

window.startBrandHueDrag = function (event) {
  const bar = document.getElementById("brand-hue-bar");
  if (!bar) return;
  const apply = (e) => {
    const rect = bar.getBoundingClientRect();
    const x = Math.max(0, Math.min(rect.width, e.clientX - rect.left));
    window.__brandHSV.h = Math.round((x / rect.width) * 360);
    updateBrandColorUI(hsvToHex(window.__brandHSV.h, window.__brandHSV.s, window.__brandHSV.v));
  };
  apply(event);
  const move = (e) => apply(e);
  const up = () => {
    window.removeEventListener("mousemove", move);
    window.removeEventListener("mouseup", up);
  };
  window.addEventListener("mousemove", move);
  window.addEventListener("mouseup", up);
};

window.startBrandColorDrag = function (event) {
  const panel = document.getElementById("brand-sv-panel");
  if (!panel) return;
  const apply = (e) => {
    const rect = panel.getBoundingClientRect();
    const x = Math.max(0, Math.min(rect.width, e.clientX - rect.left));
    const y = Math.max(0, Math.min(rect.height, e.clientY - rect.top));
    window.__brandHSV.s = Math.round((x / rect.width) * 100);
    window.__brandHSV.v = Math.round(100 - (y / rect.height) * 100);
    updateBrandColorUI(hsvToHex(window.__brandHSV.h, window.__brandHSV.s, window.__brandHSV.v));
  };
  apply(event);
  const move = (e) => apply(e);
  const up = () => {
    window.removeEventListener("mousemove", move);
    window.removeEventListener("mouseup", up);
  };
  window.addEventListener("mousemove", move);
  window.addEventListener("mouseup", up);
};

window.syncBrandColor = function (value, source) {
  let color = (value || "").trim();
  if (!color.startsWith("#")) color = "#" + color;
  if (!/^#[0-9a-fA-F]{6}$/.test(color)) return;
  const rgb = hexToRgb(color);
  if (rgb) window.__brandHSV = rgbToHsv(rgb.r, rgb.g, rgb.b);
  updateBrandColorUI(color.toUpperCase());
};

// ---------- 默认分享图上传：调用系统文件选择器后本地预览 ----------
window.handleShareImageFile = function (file) {
  if (!file) return;
  if (!file.type.startsWith("image/")) {
    UI.toast("请选择图片文件", "error");
    return;
  }
  const maxSize = 1024 * 1024;
  if (file.size > maxSize) {
    UI.toast("分享图不能超过 1MB", "error");
    return;
  }
  const reader = new FileReader();
  reader.onload = () => {
    const dataUrl = reader.result;
    const preview = document.getElementById("share-image-preview");
    const fileName = document.getElementById("share-image-file-name");
    if (preview) {
      preview.innerHTML = `<img src="${dataUrl}" alt="默认分享图" class="w-full h-full object-cover" />`;
      preview.classList.remove("text-6xl");
    }
    if (fileName) fileName.textContent = `${file.name} · ${(file.size / 1024).toFixed(0)}KB`;
    UI.toast("分享图已上传并生成预览", "success");
  };
  reader.readAsDataURL(file);
};

// ---------- 编辑游戏图标上传：调用系统文件选择器后本地预览 ----------
window.handleEditGameIconFile = function (file) {
  if (!file) return;
  if (!file.type.startsWith("image/")) {
    UI.toast("请选择图片文件", "error");
    return;
  }
  const maxSize = 500 * 1024;
  if (file.size > maxSize) {
    UI.toast("图标不能超过 500KB", "error");
    return;
  }
  const reader = new FileReader();
  reader.onload = () => {
    const dataUrl = reader.result;
    const preview = document.getElementById("edit-game-icon-preview");
    const fileName = document.getElementById("edit-game-icon-file-name");
    if (preview) {
      preview.innerHTML = `<img src="${dataUrl}" alt="游戏图标" class="w-full h-full object-cover" />`;
      preview.classList.remove("text-5xl");
    }
    if (fileName) fileName.textContent = `${file.name} · ${(file.size / 1024).toFixed(0)}KB`;
    UI.toast("游戏图标已上传并生成预览", "success");
  };
  reader.readAsDataURL(file);
};

// ---------- 添加游戏成员 Modal（管理员手动添加） ----------
window.openAddGameMemberModal = function (gameId, gameName) {
  const pwd = generateInitialPassword();
  const html = `
    <div class="fixed inset-0 z-50 flex items-center justify-center" id="add-member-mask">
      <div class="absolute inset-0 bg-ink-900/50 backdrop-blur-sm" onclick="document.getElementById('add-member-mask').remove()"></div>
      <div class="relative bg-white rounded-2xl shadow-pop w-[560px] p-6 border border-ink-200 animate-fade-up">
        <div class="flex items-start justify-between mb-5">
          <div>
            <h3 class="text-lg font-bold text-ink-900">添加游戏成员</h3>
            <p class="text-xs text-ink-500 mt-1">由管理员手动为 <strong>${gameName}</strong> 添加游戏运营或游戏研发账号</p>
          </div>
          <button onclick="document.getElementById('add-member-mask').remove()" class="w-8 h-8 rounded-lg hover:bg-ink-50 text-ink-400">✕</button>
        </div>

        <form onsubmit="event.preventDefault(); submitAddGameMember('${gameId}')">
          <div class="grid grid-cols-2 gap-4">
            <div>
              <label class="block text-sm font-medium text-ink-700 mb-1.5">姓名 <span class="text-danger-600">*</span></label>
              <input id="new-member-name" required type="text" placeholder="如：张三" class="w-full px-3 py-2.5 border border-ink-200 rounded-lg text-sm outline-none focus:border-brand-500 focus:ring-2 focus:ring-brand-100" />
            </div>
            <div>
              <label class="block text-sm font-medium text-ink-700 mb-1.5">邮箱 <span class="text-danger-600">*</span></label>
              <input id="new-member-email" required type="email" placeholder="name@company.com" class="w-full px-3 py-2.5 border border-ink-200 rounded-lg text-sm font-mono outline-none focus:border-brand-500 focus:ring-2 focus:ring-brand-100" />
            </div>
            <div class="col-span-2">
              <label class="block text-sm font-medium text-ink-700 mb-1.5">角色 <span class="text-danger-600">*</span></label>
              <div class="grid grid-cols-2 gap-3">
                <label class="cursor-pointer">
                  <input type="radio" name="new-member-role" value="operator" class="peer sr-only" required checked />
                  <div class="border border-ink-200 rounded-lg p-3 peer-checked:border-brand-700 peer-checked:bg-brand-50 hover:border-brand-300">
                    <div class="text-sm font-semibold text-ink-900">游戏运营</div>
                    <div class="text-xs text-ink-500 mt-1">运营管理：分享配置、模板、分享管理、数据分析</div>
                  </div>
                </label>
                <label class="cursor-pointer">
                  <input type="radio" name="new-member-role" value="developer" class="peer sr-only" required />
                  <div class="border border-ink-200 rounded-lg p-3 peer-checked:border-ok-700 peer-checked:bg-ok-50 hover:border-ok-300">
                    <div class="text-sm font-semibold text-ink-900">游戏研发</div>
                    <div class="text-xs text-ink-500 mt-1">研发工具：游戏管理、包体管理、SDK 监控、SDK 文档</div>
                  </div>
                </label>
              </div>
            </div>
            <div class="col-span-2">
              <label class="block text-sm font-medium text-ink-700 mb-1.5">初始密码 <span class="text-danger-600">*</span></label>
              <div class="flex items-center gap-2">
                <input id="new-member-password" required type="text" value="${pwd}" class="flex-1 px-3 py-2.5 border border-ink-200 rounded-lg text-sm font-mono bg-ink-50 outline-none" />
                <button type="button" onclick="refreshInitialPassword()" class="px-3 py-2.5 border border-ink-200 rounded-lg text-xs hover:bg-ink-50">重新生成</button>
                <button type="button" onclick="copyText(document.getElementById('new-member-password').value, '初始密码 ')" class="px-3 py-2.5 bg-brand-700 text-white rounded-lg text-xs hover:bg-brand-800">复制</button>
              </div>
              <div class="mt-2 text-xs text-warn-700 bg-warn-50 border border-warn-200 rounded-lg px-3 py-2">
                请将初始密码通过安全渠道发送给成员；成员首次登录后需要修改密码。
              </div>
            </div>
          </div>

          <div class="mt-6 pt-5 border-t border-ink-100 flex justify-end gap-2">
            <button type="button" onclick="document.getElementById('add-member-mask').remove()" class="px-4 py-2 border border-ink-200 rounded-lg text-sm hover:bg-ink-50">取消</button>
            <button type="submit" class="px-4 py-2 bg-brand-900 text-white rounded-lg text-sm hover:bg-brand-800">添加成员</button>
          </div>
        </form>
      </div>
    </div>
  `;
  document.body.insertAdjacentHTML("beforeend", html);
  setTimeout(() => document.getElementById("new-member-name")?.focus(), 100);
};

function generateInitialPassword() {
  const chars = "ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz23456789!@#$";
  let s = "Es_";
  for (let i = 0; i < 12; i++) s += chars[Math.floor(Math.random() * chars.length)];
  return s;
}

window.refreshInitialPassword = function () {
  const input = document.getElementById("new-member-password");
  if (input) input.value = generateInitialPassword();
};

window.submitAddGameMember = async function (gameId) {
  const name = document.getElementById("new-member-name")?.value.trim();
  const email = document.getElementById("new-member-email")?.value.trim();
  const role = document.querySelector('input[name="new-member-role"]:checked')?.value;
  const pwd = document.getElementById("new-member-password")?.value;
  if (!name || !email || !role || !pwd) {
    UI.toast("请补全必填信息", "error");
    return;
  }
  try {
    await gamesApi.addMember(gameId, {
      name,
      email,
      role,
      games: [gameId],
      status: "active",
    });
    await invalidateAndRefresh();
    document.getElementById("add-member-mask")?.remove();
    UI.toast("成员已添加，初始密码已生成", "success");
    setTimeout(() => renderRoute(), 200);
  } catch (err) {
    UI.toast(err?.message || "添加失败", "error");
  }
};

// ---------- 团队成员筛选 ----------
window.setMemberFilter = function (filter) {
  window.__memberFilter = filter;
  renderRoute();
};

// ---------- 变更游戏成员角色 ----------
window.openChangeMemberRoleModal = function (userId, gameId) {
  const user = MOCK.USERS.find(u => u.id === userId);
  const game = MOCK.GAMES.find(g => g.id === gameId);
  if (!user || !game) return;
  const html = `
    <div class="fixed inset-0 z-50 flex items-center justify-center" id="change-role-mask">
      <div class="absolute inset-0 bg-ink-900/50 backdrop-blur-sm" onclick="document.getElementById('change-role-mask').remove()"></div>
      <div class="relative bg-white rounded-2xl shadow-pop w-[520px] p-6 border border-ink-200 animate-fade-up">
        <div class="flex items-start justify-between mb-5">
          <div>
            <h3 class="text-lg font-bold text-ink-900">变更成员角色</h3>
            <p class="text-xs text-ink-500 mt-1">将 <strong>${user.name}</strong> 在 <strong>${game.name}</strong> 下的游戏级角色变更为：</p>
          </div>
          <button onclick="document.getElementById('change-role-mask').remove()" class="w-8 h-8 rounded-lg hover:bg-ink-50 text-ink-400">✕</button>
        </div>

        <div class="grid grid-cols-2 gap-3">
          <label class="cursor-pointer">
            <input type="radio" name="change-member-role" value="operator" class="peer sr-only" ${user.role === "operator" ? "checked" : ""} />
            <div class="border border-ink-200 rounded-lg p-4 peer-checked:border-brand-700 peer-checked:bg-brand-50 hover:border-brand-300">
              <div class="text-sm font-semibold text-ink-900">游戏运营</div>
              <div class="text-xs text-ink-500 mt-1">运营管理：分享配置、模板、分享管理、数据分析</div>
            </div>
          </label>
          <label class="cursor-pointer">
            <input type="radio" name="change-member-role" value="developer" class="peer sr-only" ${user.role === "developer" ? "checked" : ""} />
            <div class="border border-ink-200 rounded-lg p-4 peer-checked:border-ok-700 peer-checked:bg-ok-50 hover:border-ok-300">
              <div class="text-sm font-semibold text-ink-900">游戏研发</div>
              <div class="text-xs text-ink-500 mt-1">研发工具：游戏管理、包体管理、SDK 监控、SDK 文档</div>
            </div>
          </label>
        </div>

        <div class="mt-4 bg-warn-50 border border-warn-200 rounded-lg px-3 py-2 text-xs text-warn-800">
          角色变更会立即影响该成员在本游戏下可访问的功能模块。
        </div>

        <div class="mt-6 pt-5 border-t border-ink-100 flex justify-end gap-2">
          <button onclick="document.getElementById('change-role-mask').remove()" class="px-4 py-2 border border-ink-200 rounded-lg text-sm hover:bg-ink-50">取消</button>
          <button onclick="submitChangeMemberRole('${userId}')" class="px-4 py-2 bg-brand-900 text-white rounded-lg text-sm hover:bg-brand-800">确认变更</button>
        </div>
      </div>
    </div>
  `;
  document.body.insertAdjacentHTML("beforeend", html);
};

window.submitChangeMemberRole = async function (userId) {
  const role = document.querySelector('input[name="change-member-role"]:checked')?.value;
  const user = MOCK.USERS.find(u => u.id === userId);
  if (!role || !user) return;
  try {
    await adminApi.updateUser(userId, { role });
    await invalidateAndRefresh();
    document.getElementById("change-role-mask")?.remove();
    UI.toast(`已将 ${user.name} 变更为${role === "operator" ? "游戏运营" : "游戏研发"}`, "success");
    renderRoute();
  } catch (err) {
    UI.toast(err?.message || "变更失败", "error");
  }
};

// ---------- API 密钥页操作 ----------
window.openResetGameSecretModal = function (gameId, gameName) {
  UI.confirmModal({
    title: "重置 Game Secret",
    content: `
      <div class="text-sm text-ink-700 leading-relaxed">
        <p>确定要重置 <strong>${gameName}</strong> 的游戏级 Game Secret 吗？</p>
        <div class="mt-3 p-3 bg-warn-50 border border-warn-200 rounded-lg text-warn-800 text-xs">
          重置后所有包体共享的新密钥会立即生效，旧密钥将失效。你需要同步更新所有服务端部署。
        </div>
      </div>
    `,
    confirmText: "确认重置",
    onConfirm: async () => {
      try {
        const { data } = await gamesApi.rotateSecret(gameId);
        copyText(data.gameSecret, "新 Game Secret ");
        await invalidateAndRefresh();
        UI.toast("Game Secret 已重置并复制，请立即保存", "success");
      } catch (err) {
        UI.toast(err?.message || "重置失败", "error");
      }
    },
  });
};

window.openCreateApiKeyModal = function (gameId) {
  const html = `
    <div class="fixed inset-0 z-50 flex items-center justify-center" id="api-key-mask">
      <div class="absolute inset-0 bg-ink-900/50 backdrop-blur-sm" onclick="document.getElementById('api-key-mask').remove()"></div>
      <div class="relative bg-white rounded-2xl shadow-pop w-[560px] p-6 border border-ink-200 animate-fade-up">
        <div class="flex items-start justify-between mb-5">
          <div>
            <h3 class="text-lg font-bold text-ink-900">创建 OpenAPI 密钥</h3>
            <p class="text-xs text-ink-500 mt-1">用于服务端调用配置、事件或数据查询接口</p>
          </div>
          <button onclick="document.getElementById('api-key-mask').remove()" class="w-8 h-8 rounded-lg hover:bg-ink-50 text-ink-400">✕</button>
        </div>
        <div class="space-y-4">
          <div>
            <label class="block text-sm font-medium text-ink-700 mb-1.5">密钥名称 <span class="text-danger-600">*</span></label>
            <input id="new-api-key-name" value="新 OpenAPI 密钥" class="w-full px-3 py-2.5 border border-ink-200 rounded-lg text-sm outline-none focus:border-brand-500" />
          </div>
          <div>
            <label class="block text-sm font-medium text-ink-700 mb-1.5">权限范围 <span class="text-danger-600">*</span></label>
            <div class="grid grid-cols-2 gap-2 text-sm">
              ${["events:write", "analytics:read", "config:read", "config:write"].map((p, i) => `
                <label class="px-3 py-2 border border-ink-200 rounded-lg hover:bg-ink-50 cursor-pointer">
                  <input type="checkbox" value="${p}" ${i < 2 ? "checked" : ""} class="mr-1.5 api-key-scope" />${p}
                </label>
              `).join("")}
            </div>
          </div>
          <div class="bg-warn-50 border border-warn-200 rounded-lg p-3 text-xs text-warn-800">
            密钥创建后仅完整展示一次，请复制保存到服务端密钥管理系统。
          </div>
        </div>
        <div class="mt-6 pt-5 border-t border-ink-100 flex justify-end gap-2">
          <button onclick="document.getElementById('api-key-mask').remove()" class="px-4 py-2 border border-ink-200 rounded-lg text-sm hover:bg-ink-50">取消</button>
          <button onclick="finishCreateApiKey('${gameId}')" class="px-4 py-2 bg-brand-900 text-white rounded-lg text-sm hover:bg-brand-800">创建密钥</button>
        </div>
      </div>
    </div>
  `;
  document.body.insertAdjacentHTML("beforeend", html);
};

window.finishCreateApiKey = async function (gameId) {
  const name = document.getElementById("new-api-key-name")?.value?.trim() || "OpenAPI 密钥";
  const scopes = Array.from(document.querySelectorAll(".api-key-scope:checked")).map((el) => el.value);
  try {
    const { data } = await gamesApi.createApiKey(gameId, { name, scopes });
    document.getElementById("api-key-mask")?.remove();
    await invalidateAndRefresh();
    UI.confirmModal({
      title: "密钥创建成功",
      content: `<p class="text-sm text-ink-700">请立即复制保存，新密钥仅展示一次：</p><code class="block mt-3 p-3 bg-ink-50 rounded font-mono text-xs break-all">${data.key}</code>`,
      confirmText: "复制并关闭",
      onConfirm: () => copyText(data.key, "OpenAPI 密钥 "),
    });
  } catch (err) {
    UI.toast(err?.message || "创建失败", "error");
  }
};

window.openViewApiKeyModal = function (name, key, perm) {
  UI.confirmModal({
    title: name,
    content: `
      <div class="text-sm text-ink-700">
        <div class="mb-2">权限：<code class="font-mono text-xs bg-ink-100 px-1.5 py-0.5 rounded">${perm}</code></div>
        <div class="text-xs text-ink-500 mb-1">完整 App Key</div>
        <code class="block p-3 bg-ink-50 rounded font-mono text-xs break-all">${key}</code>
      </div>
    `,
    confirmText: "复制密钥",
    onConfirm: () => copyText(key, `${name} `),
  });
};

window.disableApiKey = function (name, btn) {
  UI.confirmModal({
    title: "禁用密钥",
    content: `确定要禁用 <strong>${name}</strong> 吗？禁用后依赖该密钥的服务端调用会立即失败。`,
    confirmText: "确认禁用",
    onConfirm: () => {
      const tr = btn.closest("tr");
      if (tr) {
        tr.classList.add("opacity-50");
        btn.textContent = "已禁用";
        btn.disabled = true;
        btn.className = "text-xs text-ink-400 cursor-not-allowed";
      }
      UI.toast("密钥已禁用", "success");
    },
  });
};

window.toggleWebhook = function (eventName, enabled) {
  UI.toast(`${eventName} Webhook 已${enabled ? "启用" : "停用"}`, enabled ? "success" : "info");
};

window.testWebhook = function (id, eventName) {
  const input = document.getElementById(`webhook-${id}`);
  const url = input?.value.trim();
  if (!url) {
    UI.toast(`请先填写 ${eventName} 的 Webhook URL`, "error");
    input?.focus();
    return;
  }
  if (!/^https?:\/\//.test(url)) {
    UI.toast("Webhook URL 必须以 http:// 或 https:// 开头", "error");
    input?.focus();
    return;
  }
  UI.toast(`正在向 ${eventName} Webhook 发送测试请求...`, "info");
  setTimeout(() => UI.toast(`${eventName} Webhook 测试成功：HTTP 200`, "success"), 900);
};

// __window_exports__
// Expose helpers for cross-page / inline onclick compatibility
;(window as any).continueCompleteGameBasicInfo = continueCompleteGameBasicInfo;
;(window as any).dangerRow = dangerRow;
;(window as any).dismissGameCreatedDetailOverlay = dismissGameCreatedDetailOverlay;
;(window as any).editField = editField;
;(window as any).generateInitialPassword = generateInitialPassword;
;(window as any).hexToRgb = hexToRgb;
;(window as any).highlightEmptyGameBasicFields = highlightEmptyGameBasicFields;
;(window as any).hsvToHex = hsvToHex;
;(window as any).inferPrimaryCategory = inferPrimaryCategory;
;(window as any).readonlyField = readonlyField;
;(window as any).renderGameEditTab = renderGameEditTab;
;(window as any).renderSubcategoryOptions = renderSubcategoryOptions;
;(window as any).rgbToHsv = rgbToHsv;
;(window as any).showGameCreatedDetailOverlay = showGameCreatedDetailOverlay;
;(window as any).tabApi = tabApi;
;(window as any).tabBasic = tabBasic;
;(window as any).tabBrand = tabBrand;
;(window as any).tabDanger = tabDanger;
;(window as any).tabMembers = tabMembers;
;(window as any).tabPackages = tabPackages;
;(window as any).updateBrandColorUI = updateBrandColorUI;
